import {ProductOptionType} from "../../definitions/types";

import {ProductOptionValueModel} from "./productOptionValueModel";

export class ProductOptionModel {
    private readonly _option: ProductOptionType;

    /**
     * @constructor
     * @param option {ProductOptionType}
     * @description Creates a new instance of the ProductOptionModel class.
     */
    constructor(public readonly option: ProductOptionType) {
        this._option = option;
    }

    /**
     * @method id
     * @description Returns the name of the option.
     * @returns {number}
     */
    public get name(): string | undefined {
        return this._option.name;
    }

    /**
     * @method id
     * @description Returns the unit of measurement for the option.
     * @returns {number}
     */
    public get units(): string | undefined {
        return this._option.units;
    }

    /**
     * @method id
     * @description Returns the attribute type ID of the option.
     * @returns {number}
     */
    public get attributeTypeId(): number {
        return this._option.productAttributeTypeId;
    }

    /**
     * @method id
     * @description Returns true if the option is thumbnailable, false otherwise.
     * @returns {number}
     */
    public get isThumbnailable(): boolean {
        return this._option.isThumbnailable;
    }

    /**
     * @method id
     * @description Returns the sort order of the option.
     * @returns {number}
     */
    public get sortOrder(): number {
        return this._option.sortOrder;
    }

    /**
     * @method values
     * @description Returns the values for the option.
     * @returns {ProductOptionValueModel[]}
     */
    public get values(): ProductOptionValueModel[] {
        return this._option.values.map((productOptionValue) => new ProductOptionValueModel(productOptionValue));
    }
}